import React, { useState } from 'react';
import { DesktopDatePicker, DesktopDatePickerProps } from '@mui/x-date-pickers/';
import { TextField, SxProps, Theme } from '@mui/material';
import moment from 'moment';
import { CalendarGreyIcon } from '../SvgIcons';

interface BookingFormPickerProps extends Omit<DesktopDatePickerProps<any>, 'renderInput'> {
  label: string | React.ReactNode;
  error?: boolean;
  helperText?: string;
  sx?: SxProps<Theme>;
}

const BookingFormPicker: React.FC<BookingFormPickerProps> = ({
  label,
  error,
  helperText,
  sx = {},
  minDate,
  maxDate,
  ...props
}) => {
  const startOfYear = moment().startOf('year');
  const endOfYear = moment().endOf('year');

  const [open, setOpen] = useState<boolean>(false);

  return (
    <DesktopDatePicker
      {...props}
      label={label}
      minDate={minDate ?? startOfYear}
      maxDate={maxDate ?? endOfYear}
      open={open}
      onClose={() => setOpen(false)}
      slotProps={{
        textField: {
          variant: 'filled',
          error,
          helperText,
          fullWidth: true,
          sx: {
            borderRadius: 2,
            background: 'transparent',
            fontSize: 15,
            minHeight: 44,
            '& .MuiFilledInput-root': {
              borderRadius: 2,
              background: 'transparent',
              fontSize: 15,
              minHeight: 44,
            },
            ...sx,
          },
          onClick: () => setOpen(true),
        },
        openPickerButton: {
          disabled: true,
        },
      }}
      slots={{
        openPickerIcon: CalendarGreyIcon as any,
      }}
    />
  );
};

export default BookingFormPicker;
